import React from 'react';
import styles from './_setting.module.styl';
type ExperimentPageNewExperimentSettingProps = {
  label?: string;
  subLabel?: string;
  moreInfo?: string;
  errorInfo?: string;
  children: React.ReactNode;
};
export function ExperimentPageNewExperimentSetting(props: ExperimentPageNewExperimentSettingProps) {
  return <div data-sentry-component="ExperimentPageNewExperimentSetting" data-sentry-source-file="_setting.tsx">
      {props.label && <div className={styles.label}>
          {props.label}
          {props.subLabel && <span className={styles.subLabel}>{props.subLabel}</span>}
        </div>}
      <div className={styles.input}>{props.children}</div>
      {props.moreInfo && <div className={styles.moreInfo}>{props.moreInfo}</div>}
      {props.errorInfo && <div className={styles.errorInfo}>{props.errorInfo}</div>}
    </div>;
}